import axios from "./http";

const domain = document.domain;
let baseUrl = "";
switch (domain) {
  case "localhost":
  case "bihweb.btghl.net":
    baseUrl = "https://btghotel-api-test.btghl.net/ds-web-wxapp/"; //本地请求url
    break;
  default:
    baseUrl = "https://minzu-api.btghl.net/ds-web-wxapp/";
    break;
}

axios.defaults.baseURL = baseUrl;

//上传图片
export const uploadImg = (params = {}) =>
  axios.post(`file/upload`, params, {
    "Content-Type": "application/form-data",
  });
export const uploadUrl = `${baseUrl}file/upload`;

export const login = (params = {}) => axios.post(`user/login`, params); //登录


export const getGoodsActivityList = (params = {}) => axios.post(`activity/list/forC`, params); //获取商品活动列表

export const getGoodsList = (params = {}) => axios.post(`spu/list`, { ...params, saleChannel: 2 }); //获取商品列表
export const getGroupList = (params = {}) => axios.post(`spu/getGroupList`, params); //获取渠道列表
export const getGoodInfo = (params = {}) => axios.post(`spu/get`, params); //获取商品详情
export const getListForHotem = (params = {}) => axios.post(`coupon/listForSpu`, params); //获取商品券列表
export const addBasket = (params = {}) => axios.post(`basket/addBasket`, params); //加入购物车
export const getActivity = (params = {}) => axios.post(`activity/get`, params); //获取活动详情
export const getConfirmOrder = (params = {}) => axios.post(`order/confirmOrder`, params); //获取确认订单信息
export const getSession = (params = {}) => axios.post(`order/getSessionForCredit`, params); //获取外币支付session
export const getAddressList = (params = {}) => axios.post(`deliver/list`, params); //获取收货地址
export const getUserPayDetail = (params = {}) => axios.post(`hotelOrder/getUserPayDetail`, params); //获取支付详情
export const buyGoods = (params = {}) => axios.post(`order/buyGoods`, { ...params, saleChannel: 2 }); //下订单
export const orderCreditCallback = (params = {}) => axios.post(`order/credit/callback`, params); //外币支付完成，通知服务器更新订单状态,商品
export const hotelOrderCreditCallback = (params = {}) => axios.post(`hotelOrder/credit/callback`, params); //外币支付完成，通知服务器更新订单状态，订房
export const getQrCode = (params = {}) => axios.post(`wx/getQrCode`, params); //生成菊花码
export const createLink = (params = {}) => axios.post(`shortLink/createLink`, params); //创建短连接
export const getBasketList = (params = {}) => axios.post(`basket/basketList`, params); //购物车列表
export const removeBasket = (params = {}) => axios.post(`basket/removeBasket`, params); //移出购物车
export const setBasketChecked = (params = {}) => axios.post(`basket/setChecked`, params); //设置购物车选中
export const getListForSpu = (params = {}) => axios.post(`coupon/listForSpu`, params); //优惠券_商品适用列表查询接口
export const getCouponInstance = (params = {}) => axios.post(`coupon/instance/get`, params); //优惠券_领券(单张)
export const getOrderCommonList = (params = {}) => axios.post(`order/getOrderCommonList`, params); //获取消费者订单列表
export const getOrderCommonDetail = (params = {}) => axios.post(`order/getOrderCommonDetail`, params); //获取消费者订单详情
export const cancelOrder = (params = {}) => axios.post(`order/cancelOrder`, params); //取消订单
export const getLogistics = (params = {}) => axios.post(`logistics/getLogistics`, params); //获取物流信息
export const emsConfirm = (params = {}) => axios.post(`order/emsConfirm`, params); //确认收货
export const getUserlOrderList = (params = {}) => axios.post(`hotelOrder/getUserlOrderList`, params); //酒店-用户订单列表
export const cancelHotelOrder = (params = {}) => axios.post(`hotelOrder/cancelOrder`, params); //酒店-取消订单
export const getHotelAlertOrder = (params = {}) => axios.post(`hotelOrder/getAlertOrder`, params); //酒店-入住提示获取
export const getHotelOrderDetail = (params = {}) => axios.post(`hotelOrder/getUserOrderDetail`, params); //酒店-用户订单详情
export const incrOrDecrQty = (params = {}) => axios.post(`basket/incrOrDecrQty`, params); //购物车数量增减

export const getCouponListForC = (params = {}) => axios.post(`coupon/instance/listForC`, params); //券实例_列表查询接口
export const getBasketCount = (params = {}) => axios.post(`basket/getBasketCount`, params); //获取购物车数量

export const getTenantService = (params = {}) => axios.post(`tenantService/getTenantService`, params); //获取场馆信息

export const getExtendedIntroduction = (params = {}) => axios.post(`expansion/get`, params); //获取场馆信息


//咨询
export const getArticleList = (params = {}) => axios.post(`article/getList`, params); //获取咨询列表
export const getArticleDetail = (params = {}) => axios.post(`article/get`, params); //获取咨询详情

//信息专栏
export const getInformationColumnList = (params = {}) => axios.post(`news/getList`, params); //获取咨询列表
export const getInformationColumnDetail = (params = {}) => axios.post(`news/get`, params); //获取咨询详情

//酒店配套
export const getMeetingList = (params = {}) => axios.post(`meeting/getList`, params); //获取会议室列表
export const getMeetingDetail = (params = {}) => axios.post(`meeting/get`, params); //获取会议室详情
export const getFacilityList = (params = {}) => axios.post(`facility/getList`, params); //获取其他设施列表
export const getFacilityDetail = (params = {}) => axios.post(`facility/get`, params); //获取会议室详情
//登录注册
export const getSmsCode = (params = {}) => axios.post(`user/send/sms`, params); //发送验证码
export const getLoginSms = (params = {}) => axios.post(`user/loginSms`, params); //验证码登录
//获取用户信息
export const getByUid = (params = {}) => axios.post(`user/getByUid`, params); //获取用户信息
export const getCardListAll = (params = {}) => axios.post(`card/listAll`, params); //获取会员卡等级列表
export const getFlowList = (params = {}) => axios.post(`moneybag/flow/list`, params); //获取账户流水列表
//积分
export const getScoreList = (params = {}) => axios.post(`score/list`, params); //获取积分列表
//地址管理
export const getDeliverAdd = (params = {}) => axios.post(`deliver/add`, params); //添加地址
export const modifyDeliver = (params = {}) => axios.post(`deliver/update`, params); //修改地址

export const getDeliverList = (params = {}) => axios.post(`deliver/list`, params); //获取地址列表
export const getDeliverDelete = (params = {}) => axios.post(`deliver/delete`, params); //删除地址
//行政区划树
export const getAreaTree = (params = {}) => axios.post(`area/getAreaTree`, params); //获取行政区划树
//个人资料
export const updateBaseInfo = (params = {}) => axios.post(`user/updateBaseInfo`, params); //修改姓名、邮箱
export const passwordUpdate = (params = {}) => axios.post(`moneybag/passwordUpdate`, params); //修改支付密码
export const getMoneybagSms = (params = {}) => axios.post(`moneybag/send/sms`, params); //发送验证码
export const getMoneybagCheckSms = (params = {}) => axios.post(`moneybag/checkSms`, params); //校验验证码
export const getMoneybagPasswordRest = (params = {}) => axios.post(`moneybag/passwordRest`, params); //找回支付密码
//售后申请
export const getRefundList = (params = {}) => axios.post(`order/getRefundList`, params); //售后申请列表页
export const getRefundDetail = (params = {}) => axios.post(`order/getRefundDetail`, params); //售后申请详情
export const getOrderRefundInfo = (params = {}) => axios.post(`order/getOrderRefundInfo`, params); //申请退款
// export const getAddRefundOrder = (params = {}) => axios.post(`order/addRefundOrder`, params); //申请退款
export const doRefundOrder = (params = {}) => axios.post(`order/doRefundOrder`, params); //申请退款
//订房列表
export const getListForC = (params = {}) => axios.post(`roomCalendar/getListForC`, { ...params, saleChannel: 2 }); //订房列表
export const getRoomDetail = (params = {}) => axios.post(`roomCalendar/getRoomDetail`, params); //订房详情
export const getlistForRoom = (params = {}) => axios.post(`coupon/listForRoom`, params); //获取商品优惠券列表
export const getBuildCode = (params = {}) => axios.post(`shareCode/buildCode`, params); //生成菊花码
export const getCheckRooms = (params = {}) => axios.post(`hotelOrder/checkRooms`, params); //校验订单
export const getHotelOrderConfirmOrder = (params = {}) => axios.post(`hotelOrder/confirmOrder`, params); //订单查询
export const getHotelBuyGoods = (params = {}) => axios.post(`hotelOrder/buyGoods`, { ...params, saleChannel: 2 }); //下单